import FactSection1 from './FactSection1';

export default FactSection1;